import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.date.to-iso-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState } from 'react';
import { capitalize, get, orderBy, sortBy } from 'lodash';
import { isBefore } from 'date-fns';
import { Card, createDatePickerValidator, createForm, Flex, Notice, RadioGroup, Select, Text, Tooltip, useId } from '@applyboard/crystal-ui';
import { formatDate, useTranslation } from '@applyboard/ui-utils';
import { ColorIndicator } from "../../../../components/ColorIndicator";
import { VerticalMetadata } from "../../../../components/VerticalMetadata";
import { TimelessDateStringInput } from "../../../../components/TimelessDateStringInput";
import { IntakeInfoCard } from "../../../../components/IntakeInfoCard";
import { formatTimelessDateStr } from "../../../../utils/dates";
import { replaceUnderscoresWithSpace } from "../../../../utils/formatUnderscores";
import { ProgramType, useApplicationConfiguration, useApplicationEslProgram, useApplicationMainProgram, useLegacyApplication } from "../../data";
import { validateEslIntake } from "../../utils";
import { FlexGrid } from "./FlexGrid";
import { assert } from "../../../../utils/assert";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
var _createForm = createForm(),
  Form = _createForm.Form,
  Field = _createForm.Field,
  useFieldValues = _createForm.useFieldValues;
export function IntakesForm(_ref) {
  var _ref$academicIntakeVa = _ref.academicIntakeVariant,
    academicIntakeVariant = _ref$academicIntakeVa === void 0 ? 'card' : _ref$academicIntakeVa,
    academicIntakes = _ref.academicIntakes,
    availableActions = _ref.availableActions,
    eslIntakes = _ref.eslIntakes,
    onEvent = _ref.onEvent,
    onSubmit = _ref.onSubmit,
    isUpdating = _ref.isUpdating,
    id = _ref.id;
  var _useTranslation = useTranslation('IntakesForm'),
    t = _useTranslation.t;
  var academicIntakeLabelId = useId();
  var sortByLabelId = useId();
  var _useState = useState('startDate'),
    _useState2 = _slicedToArray(_useState, 2),
    selectedSortBy = _useState2[0],
    setSelectedSortBy = _useState2[1];
  var _useApplicationEslPro = useApplicationEslProgram(),
    applicationEslProgram = _useApplicationEslPro.applicationEslProgram;
  var _useApplicationMainPr = useApplicationMainProgram(),
    applicationMainProgram = _useApplicationMainPr.applicationMainProgram;
  var initialEslIntake = (applicationEslProgram === null || applicationEslProgram === void 0 ? void 0 : applicationEslProgram.startDate) || '';
  var initialAcademicIntake = applicationMainProgram.startDate || '';
  var sortedAcademicIntakes = orderBy(academicIntakes, function (intake) {
    return get(intake, selectedSortBy) || '';
  }, selectedSortBy === 'seatAvailability.score' ? 'desc' : 'asc');
  var maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() + 5);
  var minDate = new Date();
  minDate.setFullYear(minDate.getFullYear() - 5);
  var validateDatePicked = createDatePickerValidator(minDate, maxDate, 'day');
  var eslProgramMinLength = useLegacyEslProgramMinLength();
  var allInitialIntakesFound = (!initialAcademicIntake || academicIntakes.some(function (intake) {
    return intake.startDate === initialAcademicIntake;
  })) && (!initialEslIntake || eslIntakes.some(function (intake) {
    return intake.startDate === initialEslIntake;
  }));
  assert(allInitialIntakesFound, 'Initial intake(s) not found in list of intakes');
  return _jsx(Form, {
    defaultValues: {
      eslIntake: initialEslIntake,
      eslActualStartDate: (applicationEslProgram === null || applicationEslProgram === void 0 ? void 0 : applicationEslProgram.actualStartDate) || '',
      eslAlternateActualStartDate: (applicationEslProgram === null || applicationEslProgram === void 0 ? void 0 : applicationEslProgram.alternateActualStartDate) || '',
      academicIntake: initialAcademicIntake,
      academicAlternateActualStartDate: (applicationMainProgram === null || applicationMainProgram === void 0 ? void 0 : applicationMainProgram.alternateActualStartDate) || '',
      academicActualStartDate: (applicationMainProgram === null || applicationMainProgram === void 0 ? void 0 : applicationMainProgram.actualStartDate) || ''
    },
    onSubmit: onSubmit,
    id: id,
    children: _jsxs(Flex, {
      direction: "column",
      gap: 6,
      children: [_jsxs(Flex, {
        gap: 4,
        direction: "column",
        children: [(availableActions === null || availableActions === void 0 ? void 0 : availableActions.canUpdateStartDates) && _jsxs(Flex, {
          gap: 3,
          children: [_jsx(Field, {
            name: "eslActualStartDate",
            as: TimelessDateStringInput,
            label: t('eslStartDate'),
            maxDate: maxDate.toISOString(),
            minDate: minDate.toISOString(),
            disabled: !availableActions.canUpdateEsl,
            validate: function validate(value, _ref2) {
              var values = _ref2.values,
                triggerValidation = _ref2.triggerValidation;
              if (values.eslIntake !== '' && value === '') {
                return t('eslRequiredError');
              }
              if (value && values.academicActualStartDate && isBefore(new Date(values.academicActualStartDate), new Date(value))) {
                return t('eslAfterAcademicError');
              }
              if (value && values.academicAlternateActualStartDate && isBefore(new Date(values.academicAlternateActualStartDate), new Date(value))) {
                return t('eslAfterAltAcademicError');
              }
              if (value === '') {
                return true;
              }
              triggerValidation('eslAlternateActualStartDate');
              return validateDatePicked(value);
            }
          }), _jsx(Field, {
            name: "eslAlternateActualStartDate",
            as: TimelessDateStringInput,
            label: t('altEslStartDate'),
            maxDate: maxDate.toISOString(),
            minDate: minDate.toISOString(),
            disabled: !availableActions.canUpdateEsl,
            validate: function validate(value, _ref3) {
              var values = _ref3.values;
              if (value && values.academicAlternateActualStartDate) {
                return isBefore(new Date(values.academicAlternateActualStartDate), new Date(value)) ? t('altEslAfterAltAcademicError') : true;
              }
              if (value && values.eslActualStartDate) {
                return isBefore(new Date(value), new Date(values.eslActualStartDate)) ? t('altEslBeforeEslError') : true;
              }
              if (value === '') {
                return true;
              }
              return validateDatePicked(value);
            }
          })]
        }), (availableActions === null || availableActions === void 0 ? void 0 : availableActions.canUpdateStartDates) && _jsxs(Flex, {
          gap: 2,
          children: [_jsx(Field, {
            name: "academicActualStartDate",
            as: TimelessDateStringInput,
            label: t('academicStartDate'),
            maxDate: maxDate.toISOString(),
            minDate: minDate.toISOString(),
            required: availableActions.canUpdateStartDates ? t('requiredField') : undefined,
            validate: function validate(value, _ref4) {
              var triggerValidation = _ref4.triggerValidation;
              triggerValidation('eslActualStartDate');
              return validateDatePicked(value);
            }
          }), _jsx(Field, {
            name: "academicAlternateActualStartDate",
            as: TimelessDateStringInput,
            label: t('altAcademicStartDate'),
            maxDate: maxDate.toISOString(),
            minDate: minDate.toISOString(),
            validate: function validate(value, _ref5) {
              var triggerValidation = _ref5.triggerValidation,
                values = _ref5.values;
              triggerValidation('eslAlternateActualStartDate');
              if (!value && values.eslAlternateActualStartDate) {
                return t('eslAltWithoutAcademicAltError');
              }
              return validateDatePicked(value);
            }
          })]
        })]
      }), _jsxs(Flex, {
        direction: "column",
        gap: 2,
        children: [_jsx(Field, {
          name: "eslIntake",
          as: Select,
          label: t('eslIntake'),
          emphasis: "outlined",
          appearance: "styled",
          disabled: !(availableActions !== null && availableActions !== void 0 && availableActions.canUpdateEsl) || isUpdating,
          validate: function validate(value, _ref6) {
            var values = _ref6.values;
            return validateEslIntake({
              eslProgram: {
                minLength: eslProgramMinLength
              },
              eslIntake: value,
              academicIntake: values.academicIntake
            });
          },
          children: sortBy(eslIntakes, 'startDate').map(function (eslIntake) {
            return _jsx(Select.Option, {
              label: formatTimelessDateStr(eslIntake.startDate, 'MMM YYYY'),
              value: eslIntake.startDate
            }, eslIntake.startDate);
          })
        }), _jsx(EslIntakeMayNeedUpdatedNotice, {
          applicationEslProgram: applicationEslProgram
        }), _jsx(EslInfoCard, {
          eslIntakes: eslIntakes
        })]
      }), academicIntakeVariant === 'card' ? _jsxs(_Fragment, {
        children: [_jsxs(Flex, {
          justify: "between",
          align: "center",
          pb: 4,
          children: [_jsx(Text, {
            id: academicIntakeLabelId,
            variant: "titleS",
            children: t('academicIntake')
          }), _jsxs(Flex, {
            align: "center",
            gap: 2,
            children: [_jsx(Text, {
              id: sortByLabelId,
              variant: "labelM",
              overflow: "nowrap",
              children: t('sortBy')
            }), _jsxs(Select, {
              emphasis: "outlined",
              appearance: "styled",
              value: selectedSortBy,
              onChange: function onChange(newValue) {
                onEvent === null || onEvent === void 0 ? void 0 : onEvent(newValue === 'startDate' ? 'sortByDate' : 'sortBySuccessScore');
                setSelectedSortBy(newValue);
              },
              "aria-labelledby": sortByLabelId,
              children: [_jsx(Select.Option, {
                value: "seatAvailability.score",
                label: t('successScore')
              }), _jsx(Select.Option, {
                value: "startDate",
                label: t('intake')
              })]
            })]
          })]
        }), _jsx(Field, {
          name: "academicIntake",
          as: RadioGroup,
          "aria-labelledby": academicIntakeLabelId,
          validate: function validate(value, _ref7) {
            var triggerValidation = _ref7.triggerValidation;
            triggerValidation('eslIntake');
            return true;
          },
          disabled: isUpdating,
          children: _jsx(FlexGrid, {
            children: sortedAcademicIntakes.map(function (intake) {
              return _jsx(FlexGrid.Item, {
                children: _jsx(AcademicIntakeCard, {
                  intake: intake
                })
              }, intake.startDate);
            })
          })
        })]
      }) : _jsxs(Flex, {
        direction: "column",
        gap: 2,
        children: [_jsx(Field, {
          name: "academicIntake",
          label: t('academicIntake'),
          as: Select,
          validate: function validate(value, _ref8) {
            var triggerValidation = _ref8.triggerValidation;
            triggerValidation('eslIntake');
            return true;
          },
          required: t('requiredField'),
          emphasis: "outlined",
          appearance: "styled",
          children: sortBy(academicIntakes, 'startDate').map(function (academicIntake) {
            return _jsx(Select.Option, {
              label: formatTimelessDateStr(academicIntake.startDate, 'MMM YYYY'),
              value: academicIntake.startDate
            }, academicIntake.startDate);
          })
        }), _jsx(AcademicInfoCard, {
          academicIntakes: academicIntakes
        })]
      })]
    })
  });
}
function AcademicIntakeCard(_ref9) {
  var intake = _ref9.intake;
  var _useTranslation2 = useTranslation('IntakesForm'),
    t = _useTranslation2.t;
  var _useApplicationConfig = useApplicationConfiguration(),
    applicationSuccessScoreLevels = _useApplicationConfig.applicationConfiguration.applicationSuccessScoreLevels;
  var applicableLevel = applicationSuccessScoreLevels.find(function (level) {
    var _intake$seatAvailabil;
    return level.level === ((_intake$seatAvailabil = intake.seatAvailability) === null || _intake$seatAvailabil === void 0 ? void 0 : _intake$seatAvailabil.determination);
  });
  var _useFieldValues = useFieldValues(['academicIntake']),
    academicIntake = _useFieldValues.academicIntake;
  var isSelected = academicIntake === intake.startDate;
  return _jsx(Card, {
    selected: isSelected,
    height: "fill",
    children: _jsxs(Flex, {
      direction: "column",
      gap: 3,
      children: [_jsx(RadioGroup.Option, {
        label: formatTimelessDateStr(intake.startDate, 'MMM YYYY'),
        value: intake.startDate
      }), _jsxs(VerticalMetadata, {
        children: [_jsx(VerticalMetadata.Key, {
          children: _jsxs(Flex, {
            align: "center",
            gap: 2,
            direction: "row",
            wrap: false,
            children: [_jsx(Text, {
              variant: "labelM",
              overflow: "nowrap",
              children: t('successScore')
            }), _jsx(Tooltip, {
              label: t('successScoreTooltip'),
              children: _jsx(Tooltip.Icon, {})
            })]
          })
        }), _jsx(VerticalMetadata.Value, {
          children: intake.seatAvailability && applicableLevel ? _jsxs(Flex, {
            align: "center",
            gap: 2,
            children: [_jsx(ColorIndicator, {
              colorCode: applicableLevel.colorCode
            }), _jsxs(Text, {
              children: [intake.seatAvailability.determination, " (", intake.seatAvailability.score, "%)"]
            })]
          }) : _jsx(Text, {
            contrast: isSelected ? 'mid' : 'low',
            children: t('na')
          })
        }), _jsx(VerticalMetadata.Key, {
          children: t('intakeStatus')
        }), _jsx(VerticalMetadata.Value, {
          children: capitalize(replaceUnderscoresWithSpace(intake === null || intake === void 0 ? void 0 : intake.intakeStatus))
        }), intake.submissionDeadline && _jsxs(_Fragment, {
          children: [_jsx(VerticalMetadata.Key, {
            children: t('submissionDeadline')
          }), _jsx(VerticalMetadata.Value, {
            children: formatDate(intake.submissionDeadline, 'MMM Do, YYYY')
          })]
        })]
      })]
    })
  });
}
var AcademicInfoCard = function AcademicInfoCard(_ref10) {
  var _academicIntakes$find;
  var academicIntakes = _ref10.academicIntakes;
  var _useTranslation3 = useTranslation('IntakesForm'),
    t = _useTranslation3.t;
  var _useFieldValues2 = useFieldValues(['academicIntake']),
    academicIntake = _useFieldValues2.academicIntake;
  var academicIntakeId = (_academicIntakes$find = academicIntakes.find(function (intake) {
    return intake.startDate === academicIntake;
  })) === null || _academicIntakes$find === void 0 ? void 0 : _academicIntakes$find.intakeId;
  if (!academicIntakeId) {
    return null;
  }
  return _jsx(IntakeInfoCard, {
    "aria-label": t('academicIntakeInfo'),
    intakes: academicIntakes,
    intakeId: academicIntakeId
  });
};
var EslInfoCard = function EslInfoCard(_ref11) {
  var _eslIntakes$find;
  var eslIntakes = _ref11.eslIntakes;
  var _useTranslation4 = useTranslation('IntakesForm'),
    t = _useTranslation4.t;
  var _useFieldValues3 = useFieldValues(['eslIntake']),
    eslIntake = _useFieldValues3.eslIntake;
  var eslIntakeId = (_eslIntakes$find = eslIntakes.find(function (intake) {
    return intake.startDate === eslIntake;
  })) === null || _eslIntakes$find === void 0 ? void 0 : _eslIntakes$find.intakeId;
  if (!eslIntakeId) {
    return null;
  }
  return _jsx(IntakeInfoCard, {
    "aria-label": t('eslIntakeInfo'),
    intakes: eslIntakes,
    intakeId: eslIntakeId
  });
};

/**
 * TODO: try to remove this once we can get the esl program min length from a modern API
 *
 * @see https://chat.google.com/room/AAAAm3qvLh4/IGsm3A7HmKI/IGsm3A7HmKI?cls=10
 */
function useLegacyEslProgramMinLength() {
  var _useLegacyApplication = useLegacyApplication(),
    legacyApplication = _useLegacyApplication.legacyApplication;
  var legacyEslProgram = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Esl;
  });
  return legacyEslProgram === null || legacyEslProgram === void 0 ? void 0 : legacyEslProgram.minLength;
}

/**
 * On May 28th, 2025, we (Hamed, Ben, Abhishek and Akanksha) discussed a problem
 * that occurs with the modern application API
 *
 * If the ESL program associated with a main program is changed in content-ui, then the
 * application API stops returning the previously saved ESL program for the application
 *
 * This means we can't easily show the application's current ESL intake since
 * it's not being returned by the modern application API.  It also means the ESL
 * program disappears from the modern sidebar, since the modern sidebar uses the
 * modern application API
 *
 * To remedy this, we decided to show a notice that appears if the application
 * has an ESL intake in the legacy API but no ESL intake in the modern API.
 * This indicates the ESL programs in content-ui may have changed, and so the
 * user may need to select a new ESL intake
 */
function EslIntakeMayNeedUpdatedNotice(_ref12) {
  var applicationEslProgram = _ref12.applicationEslProgram;
  var _useLegacyApplication2 = useLegacyApplication(),
    legacyApplication = _useLegacyApplication2.legacyApplication;
  var legacyEslProgram = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Esl;
  });
  if (!(applicationEslProgram !== null && applicationEslProgram !== void 0 && applicationEslProgram.startDate) && legacyEslProgram !== null && legacyEslProgram !== void 0 && legacyEslProgram.intake.startDate) {
    return _jsxs(Notice, {
      intent: "warning",
      children: ["There was previously an ESL intake selected for this application (", formatTimelessDateStr(legacyEslProgram.intake.startDate, 'MMM YYYY'), "), but the ESL programs offered for this application may have changed. Please select a new ESL intake if necessary and click \u201CSave\u201D."]
    });
  }
  return null;
}